import React, { useState, useEffect } from "react";
import {SinhalaData, EnglishData, TamilData} from  "./../../../../dummyData/handbookDummyData";
import { useSelector } from "react-redux";
import PDFViewerImage32 from "../../../../assets/PDFViewerImages/PDFViewerImage32.jpg";

const Chapter17 = () => {
    const selectedLanguage = useSelector((state) => state.language.language);
  const [language, setLanguage] = useState(SinhalaData[0]);

    useEffect(() => {
        switch (selectedLanguage.value) {
          case "english":
            setLanguage(EnglishData[0]);
            break;
          case "tamil":
            setLanguage(TamilData[0]);
            break;
          default:
            setLanguage(SinhalaData[0]);
            break;
        }
      }, [selectedLanguage]);

    return (
        <>
                 {/* Chapter 17 */}
                <section id="section17" className="drivers-handbook-section">
                    <h2 className="drivers-handbook-heading">{language.chapter17Title}</h2>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter17Paragraph1}

                    </p>

                    <div className="image-box">
                        <img src={PDFViewerImage32} alt="Traffic Rules"/>
                    </div>


                    <p className="drivers-handbook-paragraph">
                        {language.chapter17Paragraph2}
                    </p>
                </section>
        </>
    )

}

export default Chapter17;
